import React from 'react';

import { toPhone } from '@common/utils/validation';

import SatInput from '@components/common/satUI/SatInput';
import SatCheckBox from '@components/common/satUI/SatCheckBox';
import SatRadio from '@components/common/satUI/SatRadio';
import SatValidationErrMsg from '@components/common/satUI/SatValidationErrMsg';
import SatSelect from '@components/common/satUI/SatSelect';

const CustomerParamedic = props => {
  const {
    showErrorCheckMsg,
    customerInfo,
    medAddressType,
    setMedAddressType,
    medParamedicCode,
    setMedParamedicCode,
    diagnosisCode,
    setDiagnosisCode,
    addDiagnosisCode,
  } = props;

  const diagnosisCodeList = [
    { label: '일반건강확인', value: '0' },
    { label: '특별진단A', value: '2' },
    { label: '특별진단B', value: '3' },
    { label: '특별진단C', value: '4' },
    { label: '특별진단D', value: '5' },
    { label: '우량체검진(특별진단A+니코틴)', value: '7' },
  ];

  const getAddress = type => {
    let address = '';
    if (type === 'home') {
      if (customerInfo.homeZipCd) address += `(${customerInfo.homeZipCd})`;
      if (customerInfo.homeAddr) address += ` ${customerInfo.homeAddr}`;
      if (customerInfo.homeAddrDtl) address += ` ${customerInfo.homeAddrDtl}`;
    } else {
      if (customerInfo.wkplZipCd) address += `(${customerInfo.wkplZipCd})`;
      if (customerInfo.wkplAddr) address += ` ${customerInfo.wkplAddr}`;
      if (customerInfo.wkplAddrDtl) address += ` ${customerInfo.wkplAddrDtl}`;
    }

    return address;
  };

  return (
    <React.Fragment>
      <div className="infor-list pdb-20">
        <h2 className="tit-con">연락처</h2>
        <div className="box two">
          <SatInput label={'고객명'} readOnly value={customerInfo.custNm} />
          <SatInput
            label={'휴대전화번호'}
            readOnly
            value={toPhone(customerInfo.mobileTelNo)}
          />
        </div>
        <div className="box two">
          <SatInput
            label={'자택전화번호'}
            readOnly
            value={toPhone(customerInfo.homeTelNo)}
          />
          <SatInput
            label={'회사전화번호'}
            readOnly
            value={toPhone(customerInfo.wkplTelNo)}
          />
        </div>

        <h2 className="tit-con">검진장소</h2>
        <div className="box two">
          <SatCheckBox
            value={[medAddressType === 'H' ? true : false]}
            options={[{ label: '자택', value: 'H' }]}
            onChange={value => value && setMedAddressType('H')}
            disabled={!customerInfo.homeAddr}
          />
          <SatInput label={'자택주소'} readOnly value={getAddress('home')} />
        </div>
        <div>
          <div className="box two">
            <SatCheckBox
              value={[medAddressType === 'O' ? true : false]}
              options={[{ label: '회사', value: 'O' }]}
              onChange={value => value && setMedAddressType('O')}
              disabled={!customerInfo.wkplAddr}
            />
            <div className="flex1">
              <SatInput
                label={'회사주소'}
                readOnly
                value={getAddress('workplace')}
              />
            </div>
          </div>
          <SatValidationErrMsg
            visible={showErrorCheckMsg && medAddressType === ''}
            type="error"
            message="내용을 확인하고 선택해 주세요."
          />
        </div>

        <h2 className="tit-con">파라메딕</h2>
        <div className="check-box">
          <SatRadio
            value={medParamedicCode}
            options={[
              {
                label: '차 파라메딕',
                value: '0003',
              },
              {
                label: '안심 파라메딕',
                value: '0005',
              },
            ]}
            onChange={value => setMedParamedicCode(value.value)}
            name="medParamedicCode"
          />
        </div>
        <SatValidationErrMsg
          visible={showErrorCheckMsg && medParamedicCode === ''}
          type="error"
          message="내용을 확인하고 선택해 주세요."
        />

        <h2 className="tit-con">검진항목</h2>
        <div className="item-w50">
          <SatSelect
            value={diagnosisCode}
            title="검진항목"
            initOption={{ label: '선택', value: '' }}
            options={diagnosisCodeList}
            onChange={value => setDiagnosisCode(value.value)}
          />
        </div>
        <SatValidationErrMsg
          visible={
            showErrorCheckMsg &&
            diagnosisCode === '' &&
            addDiagnosisCode.length === 0
          }
          type="error"
          message="내용을 확인하고 선택해 주세요."
        />
      </div>
    </React.Fragment>
  );
};

export default CustomerParamedic;
